import { generateCode } from '../calendarVisitSchedule.schema';
import { checkMomentInPast } from './checkMomentInPast';

/**
 * Creates a visit schedule item object.
 *
 * @param {Object} prescription - The prescription object containing at least an id.
 * @param {Object} dtEvent - The date/time event object with date and time properties.
 * @param {number} index - The index used in the unique ID generation.
 * @param {string} [key] - Optional unique key (generated if not provided).
 * @returns {Object} The constructed visit schedule item.
 */
export const buildVisitScheduleItem = (dtEvent, key = generateCode()) => {
  const uniqueVisitKey = `${dtEvent.date}-${dtEvent.time}`;
  const isMomentInPast = checkMomentInPast(dtEvent.date, dtEvent.time);

  return {
    key,
    uniqueVisitKey,
    date: dtEvent.date,
    time: dtEvent.time,
    padPrescriptionIds: [dtEvent.padPrescriptionId],
    isEnabledForSelection: isMomentInPast
  };
};
